import { Duplicate } from '@icons';
import { Chip, Tooltip } from '@ds';
import { EditDraftCaseModal } from '@lp/features/modals/EditDraftCaseModal/EditDraftCaseModal';
import { useState } from 'react';
import { CaseDuplicatesList } from '@lp/features/CaseDuplicatesList';
import { useCaseDuplicatesList } from '@lp/features/CaseDuplicatesList/hooks/useCaseDuplicatesList';
import { Case } from '@/api/apis/case';

export const CaseBoardDuplicates = () => {
  const { duplicates } = useCaseDuplicatesList();
  const [draftEditModalCase, setDraftEditModalCase] = useState<Case>();

  if (!duplicates?.length) return null;

  return (
    <>
      {draftEditModalCase && (
        <EditDraftCaseModal caseInfo={draftEditModalCase} onClose={() => setDraftEditModalCase(undefined)} />
      )}
      <CaseDuplicatesList
        duplicates={duplicates}
        onDuplicateClick={(duplicate) => setDraftEditModalCase(duplicate)}
        trigger={
          <Tooltip content="Case Duplicates" placement="bottom" showArrow>
            <Chip className="bg-base-55 mr-2 rounded-3xl cursor-pointer h-[32px]">
              <div className="px-1 flex justify-center gap-1 items-center">
                <Duplicate height={22} />
                <span className="text-m-r text-black">{duplicates.length}</span>
              </div>
            </Chip>
          </Tooltip>
        }
        triggerType="click"
        withSearch
      />
    </>
  );
};
